module.exports = __webpack_public_path__ + "img/P150T_weapon_51.a51b060b.png";